/** Auftragsart aus App-Angebot (Preisarten) – Anzeige & Badge-Varianten. */

export type AuftragsartAppBadgeKind = "festpreis" | "nachweis" | "nw_fp";

function normalizeAuftragsartKey(value: unknown): string {
  return String(value || "")
    .trim()
    .toLowerCase()
    .replace(/[\s\-_/]+/g, "");
}

export function formatAuftragsartAppLabel(value: unknown): string | null {
  const raw = String(value || "").trim();
  if (!raw) return null;
  const key = normalizeAuftragsartKey(raw);
  if (key === "festpreis" || key === "fp" || key === "festpreisauftrag") return "Festpreis";
  if (key === "nachweis" || key === "nw") return "Nachweis";
  if (
    key === "nw+fp" ||
    key === "nwfp" ||
    key === "mischmasch" ||
    key === "nachweismitfestpreis"
  ) {
    return "NW + FP";
  }
  return raw;
}

export function auftragsartAppBadgeKind(value: unknown): AuftragsartAppBadgeKind | null {
  const label = formatAuftragsartAppLabel(value);
  if (!label) return null;
  if (label === "Festpreis") return "festpreis";
  if (label === "Nachweis") return "nachweis";
  if (label === "NW + FP") return "nw_fp";
  return null;
}

export function auftragsartAppBadgeClass(kind: AuftragsartAppBadgeKind | string): string {
  return `eh-auftragsart-badge eh-auftragsart-badge--${kind}`;
}

export function isAuftragsartHeroFieldLabel(label: string | null | undefined): boolean {
  return normalizeAuftragsartKey(label) === "auftragsart";
}

/** App-Angebot hat Vorrang, sonst Hero-Feld „Auftragsart“. */
export function resolveAuftragsartAppDisplay(
  appValue: unknown,
  fallbackValue?: unknown,
): { label: string; kind: AuftragsartAppBadgeKind | null } | null {
  const label = formatAuftragsartAppLabel(appValue) || formatAuftragsartAppLabel(fallbackValue);
  if (!label) return null;
  return { label, kind: auftragsartAppBadgeKind(label) };
}
